import AlpineI18n from "alpinejs-i18n";
import Alpine from "alpinejs";

// import CSS which will be used globally
import "./reset.css";
import "./style.css";
import "./themes.css";

// import functions we want to export
import * as util from "./util";
import * as color from "./color";
import * as preview from "./preview";
import * as jobicons from "./jobicons";
import * as svgloader from "./svgloader";
import * as fontloader from "./fontloader";
import * as i18n from "./i18n";

import checklist from "./checklist";
import jobSelectList from "./jobSelectList";

import CharacterData from "./characterData";

// import stuff that has code we want to execute in it
// todo: better encapsulate this stuff
import "./bgupload";
import "./checkboxaccess";

// explicitly export functions that will become available via util.myFunc()
// i plan to do this less stupidly at some point dw about it
export function getId(id) {
  return util.getId(id);
}

export function jobLongShort(string, direction) {
  return util.jobLongShort(string, direction);
}

export function rem(x) {
  return util.rem(x);
}

export function toCamelCase(str) {
  return util.toCamelCase(str);
}

export async function fetchCharData(lodestoneId) {
  Alpine.store('characterData', await Alpine.store('characterData').load(lodestoneId));
}

export function colorPickUI(preview, containerHL, inputS, inputA, initArray, callbackFunc) {
  return color.colorPickUI(preview, containerHL, inputS, inputA, initArray, callbackFunc);
}

export function updateBackground(x, y) {
  return preview.updateBg(x, y);
}

export function updateBackgroundZoom(z) {
  return preview.updateBgZoom(z);
}

export function previewModeDefault(mode) {
  return preview.prevModeDefault(mode);
}

export function saveCard() {
  return preview.saveCard();
}

export function updateDetail(x, y) {
  return preview.updateDetail(x, y);
}

export function getPrevDetailX() {
  return preview.getPrevDetailX();
}

export function getPrevDetailY() {
  return preview.getPrevDetailY();
}

export function updateSig(x, y) {
  return preview.updateSig(x, y);
}

export function updateSigAlign(align) {
  return preview.updateSigAlign(align);
}

export function switchJobDisplay(display) {
  return jobicons.switchJobDisplay(display);
}

export function updateJobSelect(array) {
  return jobicons.updateJobSelect(array);
}

export function updateUse(container, extraStyles) {
  return svgloader.updateUse(container, extraStyles);
}

export function selectFont(family, face) {
  return fontloader.selectFont(family, face);
}

export function loadGFont(fonturlArray, custom) {
  return fontloader.loadGFont(fonturlArray, custom);
}

export function selectCustomFont(face) {
  return fontloader.selectCustomFont(face);
}

export function switchLanguage(lang) {
  console.log(`Switching to ${lang}`);
  return i18n.switchLanguage(lang);
}

// set up alpine
window.Alpine = Alpine;
Alpine.plugin(AlpineI18n);

Alpine.store('characterData', new CharacterData());

Alpine.data('checklist', checklist);
Alpine.data('jobSelectList', jobSelectList);

Alpine.start();


